import { registerEvents } from "./skyward.ui.events";
import { JQueryInput } from "./types";

const classNames =
{
    uiDisabled: "ui-disabled"
};

const events =
{
    init,
    initSXL2
};

registerEvents("comboBox", events);

function init(selector: JQueryInput)
{
    const comboBox = $(selector);
    addListeners(comboBox);
}

function initSXL2(selector: JQueryInput)
{
    const comboBox = $(selector);

    if (comboBox.is(":disabled"))
    {
        comboBox.removeAttr("disabled").addClass(classNames.uiDisabled);
        comboBox.attr("aria-readonly", "true");
    }

    addListeners(comboBox);
}

function addListeners(comboBox: JQuery<HTMLElement>)
{
    comboBox.on("mousedown touchstart click keydown wheel", function (this: HTMLElement, e: JQuery.Event)
    {
        if (this.classList.contains(classNames.uiDisabled) && e.key !== "Tab")
        {
            if (e.type !== "wheel" && e.type !== "keydown")
            {
                this.focus();
            }
            
            e.preventDefault();
            e.stopPropagation();
        }
    });
}